import React from 'react';
import Select from "react-select";
import {useTranslation} from "react-i18next";

const SupplierDocumentsTypeSelect = props => {
  const { t } = useTranslation('supplier_create')
  const [value, setValue] = React.useState(props.value);

  const options = [
    {
      label: t('supplier._global.documents_type_select.1'),
      value: 1,
    },
    {
      label: t('supplier._global.documents_type_select.2'),
      value: 2,
    },
  ]

  return <Select
    menuPortalTarget={document.body}
    classNamePrefix="react-select"
    options={options}
    isDisabled={props.isDisabled}
    value={options.find(o => o.value === value)}
    placeholder={t('common:select.placeholder')}
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />
};

SupplierDocumentsTypeSelect.propTypes = {

};

export default SupplierDocumentsTypeSelect;
